import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import TextField from 'lib/ui/TextField'
import HTMLEditor, {HTMLEditorContainer} from 'lib/ui/form/HTMLEditor'
import {FAQ} from 'Event/FAQs'
import {onChangeCheckedHandler} from 'lib/dom'
import Switch, {EnabledSwitch} from 'lib/ui/form/Switch'
import Title from 'lib/ui/ConfigPanel/Title'
import {useAttendeeVariables} from 'Event'

export default function Settings(props: {
  control: UseFormMethods['control']
  register: UseFormMethods['register']
  faq: FAQ
}) {
  const {control, register, faq} = props
  const v = useAttendeeVariables()

  return (
    <>
      <Controller
        name="enabled"
        control={control}
        defaultValue={faq.enabled}
        render={({onChange, value}) => (
          <EnabledSwitch
            checked={value}
            onChange={onChangeCheckedHandler(onChange)}
            aria-label="toggle enable"
          />
        )}
      />
      <Controller
        name="showAnswerOnLoad"
        control={control}
        defaultValue={faq.showAnswerOnLoad}
        render={({onChange, value}) => (
          <Switch
            checked={value}
            onChange={onChangeCheckedHandler(onChange)}
            labelPlacement="end"
            label={value ? 'Show on Load Enabled' : 'Show on Load Disabled'}
          />
        )}
      />
      <Title>Question</Title>
      <TextField
        name="question"
        required
        fullWidth
        aria-label="faq question"
        inputProps={{
          ref: register({required: 'Faq question is required.'}),
        }}
        defaultValue={v(faq.question)}
      />
      <Controller
        name="answer"
        control={control}
        defaultValue={v(faq.answer || '')}
        render={({onChange, value}) => (
          <HTMLEditorContainer>
            <HTMLEditor data={value} onChange={onChange} />
          </HTMLEditorContainer>
        )}
      />
    </>
  )
}
